<style scoped>
.modal .form {
  width: 700px;
}
.search {
  float: right;
}
.item hr {
  border: 0;
  border-top: 1px solid #eee;
}
td {
 position: relative;
}
.gray {
  color: #ccc;
}
.data-table td.form-msg {
  overflow: visible;
}
.data-table td.url {
  overflow: hidden;
  max-width: 100px;
  text-overflow: ellipsis;
}
.marginTop {
  margin-top: 15px;
}
.toolbar-row {
  margin: 15px;
}
.modal .data-table th,
.modal .data-table td {
  padding: 0 10px;
}
.bdb {
    border-bottom: 1px solid #e5e5e5;
}
.zone td .btn:first-child {
  padding-left: 0;
}   
</style>

<template lang="pug">
.report
  PageTitle(
    pagetitle="路径分析",
    tip="路径分析报告帮助您深入洞察用户访问或点击行为，发现并监测关键转化路径，进而进行路径优化，提升转化率")
    span.floatr(v-if="currentView == 'analysis'")
      label 路径名称：
      v-input(
        :disabled="true",
        placeholder="未设置路径",
        v-if="pathList.length == 0")
      v-select(
        v-model="currentPathId",
        @input="changePathId",
        :options="pathList",
        v-if="pathList.length > 0")
      
  ul.tab
    li.tab-item(v-for="item in tabViews")
      .tabview-btn(
              @click.prevent="changeViewTo(item.comp)",
              :class="{ active: currentView === item.comp}"
            ) {{item.title}}

  div(v-if="currentView == 'analysis'")
    div.time
      TimeSpan(
        filters="yesterday",
        @change="onTimespanChange")
    .zone
      TableTitle(icon="fa fa-signal" title="趋势图")
      table.data-table
        tr
          td.chart-path(
            width="30%",
            style="padding: 20px 0px 20px 30px;vertical-align: top;")
            .total-conv {{ totalRate | percentage }}
            .path-conv-line(v-for="info in stepTrateList")
              .conv-name(
                v-if="!isRateShow(info)",
                :class="info.classname"
              ) {{info.name}}
              .conv-mount(v-if="!isRateShow(info)")
                  div
                    img(
                      :style="{'margin-right': '7px', 'vertical-align':'middle'}",
                      src="http://p1.qhimg.com/t01b24d917730ef1175.png",
                      v-show="prefix === 'UV'")
                    img(
                      :style="{'margin-right': '7px', 'vertical-align':'top'}",
                      src="http://p4.qhimg.com/t01d593ed1a7672dd5f.png",
                      v-show="prefix === '访问'")
                    span(style="color: #a1b1be;font-size: 12px;") {{info.prefix}}
                  div(style="color: #596980;margin-top: 5px;font-size: 16px") {{info.tnum}}
              .path-radio-v(
                v-if="isRateShow(info)",
                :class="info.classname"
              ) {{ info.trate| percentage}}
          td(width="70%")
            LineChart(
              v-bind:legend="legend",
              v-bind:xAxis="chartXAxis",
              v-bind:series="chartSeries")

    .zone
      TableTitle(
        icon="fa fa-list",
        v-bind:title="tableTabTitle")
      div.nav-tabs
        TabContent(
          title="主维度：",
          v-bind:tablist="tablist")
          DownloadBtn(
            slot="extentTab",
            v-bind:reportApi="reportApi",
            v-bind:params="query",
            :pagetitle="tableTabTitle",
            subtitle="",
            v-if="total > 0")
          div(slot="funnel") 
            p.plan-nav(v-show="sdimOptions.length > 0")
              | 选择二级维度：
              v-radio-group(
                v-model="sdim",
                name="secondaryDim",
                v-bind:options="sdimOptions",
                @change.native="getTableData()")
            p.tabAction
              button.btn.btn-primary.btn-big(
                v-bind:disabled="fetchLineChartabled",
                @click="fetchLineChartData") 绘制选定行

      complex-table(
        classname="report-path data-table",
        v-bind:columns="columns",
        v-bind:list="tableDataList",
        v-bind:sum="{}",
        v-bind:checkbox="hasCheckBox",
        v-bind:checkbox_length="checkboxLength")
      v-pagination(
        :total="total",
        v-bind:pn="pg",
        v-bind:ps="ps",
        v-if="total > ps",
        @updatepage="getTableData")

  div.marginTop(v-if="currentView == 'setting'")
    .zone
      TableTitle.bdb(icon="fa fa-list" title="路径列表")
      .toolbar-row
        button.btn.btn-primary.btn-big(@click="openSettingMadol") 转化路径设置

      table.data-table
            thead
              tr
                th(width="40%") 转化路径名称 
                th(width="40%") 创建时间
                th(width="20%") 操作 
            tbody(v-if="pathList.length == 0")
              tr
                td.noresult(colspan=3) 暂无相关数据

            tbody(v-if="pathList.length > 0")
              tr(v-for="(item, index) in pathList")
                td {{item.name}}
                td {{item.createtime}}
                td 
                  .btn(@click="changeToFunnel(item)") 查看漏斗
                  .btn(@click="currentStepInfo(item)") 详情
                  .btn(@click="removeStepInfo(item, index)") 删除

  v-modal(
    :visible="pathSettingVisible",
    :title="'转化路径设置'",
    :subTitle="'(转化路径步骤最少设置2步，最多可设置5步)'"
    ref="formModal",
    @closemodal="closeMadol")
    .modal-bd
      .modal-content.convert-path
        v-form(v-model="pathSetting",
                ref="pathform")
          .item
            .label 路径名称：
            .control 
                span(v-if="steplist.length > 0") {{pathSetting.name}}
                v-input(
                  v-if="steplist.length == 0",
                  v-model="pathSetting.name",
                  placeholder="请输入1-10字符名称",
                  @input.native="pathSettingNameMsg = ''",
                  :rules="rules.name")
                em(v-show="pathSettingNameMsg != ''") {{pathSettingNameMsg}}
          .item
            .label 数据统计：
            .control 
              v-select(
                :disabled="steplist.length > 0",
                :options="availableOptions",
                v-model="pathSetting.type")
              //select(
                :disabled="steplist.length > 0",
                v-model="pathSetting.type")
                option(
                  v-for="type in availableOptions",
                  :value="type.id",
                  :key="type.id") {{type.value}}
              v-tooltip(
                tip="选择按访问统计，则记录一次访问内完成路径的用户的行为数据；选择按天统计，则记录一天内完成路径的用户的行为数据",
                pos="right")
                i.fa.fa-question-circle
          .item
            .label 转化路径：
            .control 
              .btn(
                :class="addStepInfoClass",
                v-show="stepAddlist.length < 5 && steplist.length == 0",
                @click="addNewStep"
              ) 添加步骤
              table.data-table(style="table-layout: fixed;max-width: 800px;")
                thead
                  tr
                    th(width="7%") 步骤
                    th(width="18%") 步骤名称
                    th(width="36%") 页面URL
                    th(width="20%") 事件ID
                    th(width="19%" v-show="steplist.length == 0") 操作
                tbody
                  tr(
                    v-show="steplist.length > 0",
                    v-for="detail in steplist"
                  )
                    td {{detail.step_seq}}
                    td {{detail.name}}
                    td(:title="detail.url") {{detail.url}}
                    td {{detail.eventid}}
                  tr(
                    v-show="stepAddlist.length > 0",
                    v-for="detail,index in stepAddlist"
                  )
                    td {{index +1}}
                    td(v-if="!stepAddabled(detail)") {{detail.name}}
                    td.form-msg(v-if="stepAddabled(detail)")
                      v-input.size-small(
                        placeholder="请输入步骤名称",
                        v-model="stepName",
                        :rules="rules.stepname",
                        ref="stepname")
                    td(
                      v-if="!stepAddabled(detail)",
                      :title="detail.url"
                    ) {{detail.url}}
                    td.form-msg(v-if="stepAddabled(detail)")
                      v-input(
                        placeholder="请输入URL如：http://fenxi.com，可通配",
                        v-model="stepUrl",
                        :rules="rules.url",
                        ref="stepurl")
                    td(v-if="!stepAddabled(detail)") {{detail.eventid}}
                    td(v-if="stepAddabled(detail)")
                      v-input.size-small(
                        placeholder="非必填",
                        v-model="stepEventid")
                    td 
                      .btn.btn-primary(
                        v-show="stepAddabled(detail)",
                        @click.prevent="saveStep(detail)"
                      ) 保存
                      .btn.btn-primary(
                        v-show="index != 0",
                        @click.prevent="delStep(index)"
                      ) 删除
                      .btn.btn-primary(
                        v-show="index == 0 && !stepAddabled(detail)",
                        @click.prevent="delStep(index)"
                      ) 删除

          .item(v-show="steplist.length == 0")
              span.tip 若转化步骤为某页面的浏览量，则不用填写事件ID；若转化步骤为某点击事件，则既需要填写页面URL也需要填写事件ID。
              a.btn(
                target="_blank",
                href="https://fenxi.360.cn/help/manual?target=conversion"
              ) 详见如何获取ID

          .item(v-show="steplist.length == 0")
            .label
              button.btn.btn-primary(
                @click.prevent="stepInfoSubmit",
                :disabled="stepAddlist.length < 2"
              ) 确认
              button.btn.btn-white(
                type = "reset",
                @click.prevent="stepInfoReset"
              ) 清空
</template>

<script>
  import Mixin from '../mixin.js'
  import Table from '../../component/complex-table.vue'
  export default {
    mixins: [Mixin],
    components: {
      'complex-table': Table
    },
    data() {
      return {
        addPath: true,
        steplistShow: false,
        steplist: [],
        stepAddlist: [],
        stepName: "",
        stepUrl: "",
        stepEventid: "",
        step: {
          sid: 1,
          name: '',
          url: '',
          eventid: ''
        },
        pathList: [],
        currentPathId: null,
        chartResList: [],
        hasCheckBox: true,
        checkboxLength: 1,
        total: 0,
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        isasc: 0,
        order: '',
        legend: [],
        currentTab: 'funnel',
        currentView: 'analysis',
        tablist: [
                      {
                        id: 'funnel', 
                        name: '路径名称', 
                        reportTableApi:'/api/funnel/report?groupby=funnel',
                        reportLineChartApi: '/api/funnel/report?groupby=funnel,date'
                      }
                    ],
        tabViews: [
          {
            comp: "analysis",
            title: "漏斗分析",
          },
          {
            comp: "setting",
            title: "转化路径设置"
          }
        ],
        chartXAxis: [],
        chartSeries: [],
        sdimOptions: [],
        list: {},
        tableDataList: [],
        defaultPathSetting: {
          name: '',
          type: 1
        },
        prefix: '',
        totalRate: '-',
        stepTrateList: [],
        pathSetting: {},
        pathSettingVisible: false,
        convPathList: [],
        addNewStepabled: true,
        pathSettingNameMsg: '',
        rules: {
          name: {
            maxlength: 10,
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
            msg: {
              maxlength: '路径名称不超过10个字符',
              pattern: '只能输入中文，英文和数字'
            }
          },
          stepname: {
            required: true,
            maxlength: 6,
            pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/,
            msg: {
              required: '请填写路径名称',
              maxlength: '不可超过6字符',
              pattern: '只能输入中文，英文和数字'
            }
          },
          url: {
            pattern: /^https?:\/\/[a-zA-Z0-9][a-zA-Z0-9\-]*\.[a-zA-Z0-9]+[^\s]*\s*$/,
            required: true
          }
        }
      }
    },
    filters: {
      percentage(s) {
        if(s == null || _.isNaN(parseFloat(s))) return '-';

        return s == 0 ? '0%' : ((parseFloat(s) * 100).toFixed(2) + '%');
      }
    },
    computed: {
      addStepInfoClass() {
        return this.addNewStepabled ? 'btn-icon btn-primary' : 'gray'
      },
      availableOptions() {
        let option = [
          { label: "访问", value: 1 },
          { label: "一天", value: 2 }
        ]
        return option
      },
      uiError() {
        return this.$store.state.uiError
      },
      domainId() {
          return this.$store.state.domainId;
      },
      fetchLineChartabled() {
        return this.$store.state.tableCheckList.length == 0 || !this.$store.state.drawChartabled
      },
      reportApi() {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      },
      start() {
        return this.$store.state.tableCheckList.length == 0 || !this.$store.state.drawChartabled
      },
      end() {
        return this.$store.state.end.replace(/-/g, '/')
      },
      tableTabTitle() {
        return '路径分析报表'
      },
      columns(){
        let defaultColumn = [
          {title: "路径名称", key: "name"}
        ]
        let newIndices = []
        let indices = [['trate', '总转化率'], ['tnum1', '步骤一'], ['trate1', ''], ['tnum2', '步骤二'], ['trate2', ''],
        ['tnum3', '步骤三'], ['trate3', ''], ['tnum4', '步骤四'], ['trate4', ''],  ['tnum5', '步骤五']]
        let names = []

        if(this.tableDataList.length > 0){
          names = ['stepName1', 'stepName2', 'stepName3', 'stepName4', 'stepName5'].map( name => {
            return _.result(this.tableDataList[0], name)
          })
          names = names.filter( name => name )
          newIndices.push(['trate', '总转化率'])
          _.forEach(names, (name, i) => {
            newIndices.push([`tnum${i+1}`, name])
            newIndices.push([`trate${i+1}`, ''])
          })
          newIndices.pop()
        }
        if(newIndices.length > 0){
          indices = newIndices
        }

        _.each(indices, (item) => {
          if(/trate/.test(item[0])){
            defaultColumn.push({
              title: item[1], 
              key: item[0],
              class: "right",
              render: this.percentRender
            })
          } else {
            defaultColumn.push({
                                title: item[1],
                                class: "right",
                                key: item[0]
                              })
          }
        })
        return defaultColumn
      },
      query() {
        let params = {
          cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
          domainId: this.domainId,
          start: this.$store.state.start,
          end: this.$store.state.end,
          funnelId: this.currentPathId,
          pvtype: 0,
          pg: this.pg,
          ps: this.ps,
          mdim: this.currentTab,
          timespan: new Date().getTime()
        }
        if(this.sdim != 'null'){
          params = _.assignIn({sdim: this.sdim}, params)
        }
        return params
      }
    },
    watch: {
      uiError() {
        this.$Modal.warn(this.uiError.errMsg)
      },
      domainId() {
        this.getPathSettingList()
      },
    },
    mounted() {
        this.getPathSettingList()
    },
    methods: {
      changeViewTo(comp) {
        let view = _.find(this.tabViews, { comp });
        if(view){
          this.currentView = view.comp;
        }
      },
      changeToFunnel(item) {
        this.currentPathId = item.id
        this.changeViewTo('analysis')
        this.getTableData()
      },
      isRateShow(info) {
        return _.has(info, 'trate')
      },
      closeMadol() {
        this.pathSetting = _.assignIn({}, this.defaultPathSetting)
        this.steplist = []
        this.stepAddlist = []
        this.pathSettingVisible = false
      },
      stepInfoSubmit() {
        if(!this.addNewStepabled){
          return this.$Modal.warn("有未保存的步骤")
        }
        if(!/^[a-zA-Z0-9\u4e00-\u9fa5]{1,10}$/.test(this.pathSetting.name)){
          this.pathSettingNameMsg = "请填写不超过10个字符的中文，英文和数字"
          return
        }
        if(this.pathList.length == 10) {
          this.stepInfoReset()
          return this.$Modal.warn("最多可设置10条转化路径")
        }
        let steps = this.stepAddlist.map((step, i) => {
          return {
            sid: i + 1,
            sname: step.name.trim(),
            surl: step.url.trim(),
            eventid: step.eventid.trim()
          }
        })
        let stepInfoPromise = this.$http.get('/api/funnel/add', {params: {
            name: this.pathSetting.name.trim(),
            domainId: this.domainId,
            step: JSON.stringify(steps),
            type: this.pathSetting.type,
            timespan: new Date().getTime()
        }})
        this.$store.dispatch("VUE_HTTP", [stepInfoPromise])
          .then((res) => {
            this.getPathSettingList()
            this.stepInfoReset()
            this.closeMadol()
          })
      },
      stepInfoReset() {
        this.pathSetting = _.assignIn({}, this.defaultPathSetting)
        this.backtoAdd()
      },
      removeStepInfo(item,index) {
        let infoDelPromise = this.$http.get('/api/funnel/delete',{
                params: {
                  cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
                  domainId: this.domainId,
                  id: item.id,
                  timespan: new Date().getTime()
                }
              })
        this.$store.dispatch("VUE_HTTP", [infoDelPromise])
        .then((res) => {
          if(res) {
            this.pathList.splice(index, 1)
            this.$Modal.alert('删除成功')
            this.modalCenter()
          }
        })
      },
      backtoAdd() {
        this.steplist = []
        this.stepAddlist = []
        this.addNewStepabled = true
        this.addNewStep()
      },
      addNewStep() {
        if(!this.addNewStepabled) return
        this.addNewStepabled = false
        this.stepAddlist.push({
          name: "",
          url: "",
          eventid: ""
        })
        this.stepName = ""
        this.stepUrl = ""
        this.stepEventid = ""
      },
      currentStepInfo(item) {
        this.stepAddlist = []
        this.pathSetting.name = item.name
        this.pathSetting.type = item.type
        let infoPromise = this.$http.get('/api/funnel/detail',{
                params: {
                  cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
                  domainId: this.domainId,
                  funnelId: item.id,
                  timespan: new Date().getTime()
                }
              })
        this.$store.dispatch("VUE_HTTP", [infoPromise])
        .then((res) => {
          if(res) {
            this.steplist = res.list
            this.pathSettingVisible = true
          }
        })
      },
      stepAddabled(detail) {
        return detail.name == ''
      },
      delStep(index) {
        this.stepAddlist.splice(index, 1)
        if(this.stepAddlist.length == 0){
          this.addNewStep()
        }else{
          this.addNewStepabled = true
        }
      },
      modalCenter() {
        // modal 垂直居中
        let modalRef = this.$refs.formModal
        let centerFn = modalRef._centerModal
        this.$nextTick(() => centerFn && modalRef._centerModal())
      },
      saveStep(step) {
        if(!this.$refs.stepname[0].validate().valid || !this.$refs.stepurl[0].validate().valid) return
        if(_.includes(_.map(this.stepAddlist, (item) => item.name), this.stepName)){
          return this.$Modal.warn('步骤名称重复')
        }
        if(_.includes(_.map(this.stepAddlist, (item) => item.url), this.stepUrl)){
          return this.$Modal.warn('URL重复')
        }
        this.addNewStepabled = true
        this.$set(step, 'name', this.stepName)
        this.$set(step, 'url', this.stepUrl)
        this.$set(step, 'eventid', this.stepEventid)
        this.modalCenter()
      },
      openSettingMadol() {
        this.pathSetting = _.assignIn({}, this.defaultPathSetting)
        this.pathSettingVisible = true
        this.addNewStepabled = true
        this.addNewStep()
      },
      changePathId() {
        this.prefix = _.find(this.pathList, {id: this.currentPathId}).type == 1 ? '访问' : 'UV'
        this.getTableData()
        this.changeViewTo('analysis')
      },
      getPathSettingList() {
        if (!this.domainId) return;
        let pathListPromise = this.$http.get('/api/funnel/list', {params: {domainId: this.domainId}})
        this.$store.dispatch("VUE_HTTP", [pathListPromise])
          .then((res) => {
            if(res){
              this.pathList = res.list.map(item => {
                item.value = item.id
                item.label = item.name + ''
                return item
              })
              if(res.list.length > 0){
                this.currentPathId = res.list[0].id
                this.prefix = res.list[0].type == 1 ? '访问' : 'UV'
              }else{
                this.prefix = ''
                this.currentPathId = null
              }
              this.getTableData()
            }
          })
      },
      onTimespanChange({start, end}) {
        this.compareStart = start
        this.compareEnd = end
        if((new Date(end) - new Date(start)) > 365*24*3600*1000){
          return this.$Modal.warn(`您选择时间段超过了一年`)
        }
        if(this.currentPathId){
          this.getTableData()
        }
      },

      //清除报表和绘图数据
      resetData() {
        this.tableDataList = []
        this.totalRate = '-'
        this.stepTrateList = []
        //清空画图数据
        this.legend = [] 
        this.chartXAxis = []
        this.chartSeries = []
      },
      //获取图表数据
      indiceChange() {
        //步骤图表数据
        this.totalRate = this.$store.state.tableCheckList[0].trate
        let names = ['stepName1', 'stepName2', 'stepName3', 'stepName4', 'stepName5'].filter( name => {
          return _.has(this.chartResList[0], name)
        })
        let stepTrateList = []
        let list = this.$store.state.tableCheckList[0]
        _.forEach(names, (name, i) => {
          stepTrateList.push({
            prefix: this.prefix,
            name: list[name],
            classname: `tnum${i+1}`,
            tnum: list[`tnum${i+1}`]
          })
          if(_.has(list, `trate${i+1}`)){
            stepTrateList.push({
              classname: `trate${i+1}`,
              trate: list[`trate${i+1}`]
            })
          }
        })

        this.stepTrateList = stepTrateList
        //折线图数据
        let xAxis = [], series = [], legendNames = []
        let selectedIndices = []
        selectedIndices = ['trate1', 'trate2', 'trate3', 'trate4'].filter( name => _.has(this.chartResList[0], name))
        //获取legendname
        let sdimname = _.isNull(this.chartResList[0].sdimname) || _.isUndefined(this.chartResList[0].sdimname) ? '' : this.chartResList[0].sdimname + ':'
        legendNames = _.concat(['总转化率'], selectedIndices.map((trate, index) => `${sdimname}转化率${index + 1}`))
        selectedIndices = _.concat(['trate'], selectedIndices)
        //数据补足
        let lineDatas = this.fieldLoseData({start: this.$store.state.start, end: this.$store.state.end}, this.chartResList);
        //获取xAxis
        xAxis = _.map( lineDatas, 'date' )
        //获取series
        _.forEach( selectedIndices, (selectedIndice, i) => {
            let seriesData = _.map( lineDatas, selectedIndice )
            series.push( {name: legendNames[i], data: seriesData} )
        }) 


        this.legend = legendNames
        this.chartXAxis = xAxis
        this.chartSeries = series
      },
      getTableData(pn = 1) {
        this.pg = pn
        if(!this.domainId || !this.currentPathId) return
        this.total = 0
        this.$store.dispatch("SET_TABLE_LOADING", true)
        this.$store.dispatch("SET_TABLE_CHECKLIST", [])
        let reportPromise = this.$http.get(_.find(this.tablist, {id: this.currentTab}).reportTableApi, {params: this.query})
        this.$store.dispatch("VUE_HTTP", [reportPromise])
        .then((res) => {
          if(res){
            this.$store.dispatch("SET_TABLE_LOADING", false)
            this.sdimOptions = _.has(res, 'ext_info') ? this.getSdimOptionList(res.ext_info) : []
            let reportlist = this.addItemChecked(res.list)
            this.tableDataList = reportlist
            this.total = res.total
            if(reportlist.length > 0){
              let checklist = _.concat([], reportlist[0])
              this.$store.dispatch("SET_TABLE_CHECKLIST", checklist)
              this.fetchLineChartData()
            }else{
              this.resetData()
            }

          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// path.vue?6ed4e068